import { getMasterData } from "../store/listing/listingSlice";

export const GetFormTemplateData = (fields = [], formData = {}) => {
    const data = {};
    fields.map((field) => {
        if (Array.isArray(field.fields))
            data[field.field] = GetFormTemplateData(field.fields, formData[field.field] || {})
        else if (formData.hasOwnProperty(field.field))
            data[field.field] = formData[field.field];
        else
            data[field.field] = undefined
    })
    return data;
}

export function editCascadingFieldsHandler(fields, row, dispatch) {
  return new Promise(async (resolve, reject) => {
    const fields_ = JSON.parse(JSON.stringify(fields));
    const metaFields = fields_.filter((x) => x.name == "metadata").map((x) => x.fields)[0];
    let metaFieldValue = {};
    if(row?.metadata){
      Object.keys(row.metadata).forEach(key => row.metadata[key] === undefined && delete row.metadata[key]);
      metaFieldValue = Object.entries(row?.metadata).reduce((acc, [tag, { key, val }]) => {
          acc[tag] = val;
          return acc;
        },{});
    }

    const promises = [];
    for (let i = 0; i < metaFields?.length; i++) {
      const x = metaFields[i];
      if (!x.options) {
        if (x.mappedParentField) {
          const tagvalue = x.mappedParentField.split(".").pop();
          promises.push(
            new Promise((resolve, reject) => {
              dispatch(
                getMasterData({
                  name: metaFieldValue[tagvalue] + ":" + x.dataMappingAtRuntime,
                })
              ).then((res) => {
                const newField = { ...x, options: res?.payload?.data?.data };
                metaFields[i] = newField;
                resolve();
              }).catch((error) => {
                reject(error);
              });
            }));
        }
      }
    }
    Promise.all(promises).then(() => {
      fields_.map((x) => {
        if (x.name == "metadata") {
          x.fields = metaFields;
          return fields_;
        }
      });
      resolve(fields_);
    }).catch((error) => {
      reject(error);
    });
  });
}

const updateEditEnabled = (obj, metaFields) => {
  if (obj.edit) {
    obj.edit.editable = false;
  }
  if (obj.fields) {
    obj.fields.forEach(field => updateEditEnabled(field, metaFields));
  }
  if(!obj.options){
    obj.options=[metaFields[obj.field]?metaFields[obj.field]:{}]
  }
};

export function generalInfoField(fields,metaFields){
  let fields_ = JSON.parse(JSON.stringify(fields));
  fields_ = fields_.filter(x => (x.edit && x.edit.enabled && x.edit.type!='upload') || x.fields)
  fields_.map(x => {
    const updatedObj = { ...x };
    updateEditEnabled(updatedObj,metaFields);
    return updatedObj;
  });
  return fields_
}